
import ChildComponent from './child.js'
import LoginComponent from './login.js'
import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import HouseholdComponent from './household';

import React, { Component } from 'react';
import './App.css';
import HomePage from './homepage.js';
import HouseholdPage from './householdpage.js';
import VillageRequestPage from './villagerequestpage.js';
import AdminPage from './adminpage.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthCallbackPage from './authcallbackpage.js';
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Routes>
            <Route path="/" element={<HomePage />} exact />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/adminLocal" element={<AdminPage />} />
            <Route path="/showHousehold" element={<HouseholdPage />} />
            <Route path="/showHouseholdLocal" element={<HouseholdPage />} />
            <Route path="/villageRequest" element={<VillageRequestPage />} />
            <Route path="/villageRequestLocal" element={<VillageRequestPage />} />
            <Route path="/authCallback" element={<AuthCallbackPage />} />
            <Route path="/authCallbackLocal" element={<AuthCallbackPage />} />
            <Route element={Error} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;

// <Route exact path="/household" component={HouseholdPage} />